import React, { memo, useMemo, forwardRef } from 'react';
import classNames from 'classnames';
import { flexRender } from '@tanstack/react-table';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import PropTypes from 'prop-types';

const CellContent = forwardRef(({ id, content, isDragging, transform, transition }, ref) => (
  <td
    ref={ref}
    className={classNames('NewBaseTable__col', {
      'NewBaseTable__col-dragging': isDragging,
    })}
    style={{
      width: `calc(var(--col-${id}-size) * 1px)`,
      transform: CSS.Translate.toString(transform),
      transition,
    }}>
    {content}
  </td>
));

const MemoziedCellContent = memo(
  CellContent,
  (prev, next) =>
    prev.id === next.id &&
    prev.content === next.content &&
    prev.isDragging === next.isDragging &&
    prev.transition === next.transition &&
    CSS.Translate.toString(prev.transform) === CSS.Translate.toString(next.transform)
);

const DraggableCell = ({ cell }) => {
  const { isDragging, setNodeRef, transform, transition } = useSortable({
    id: cell.column.id,
  });

  const content = useMemo(
    () => flexRender(cell.column.columnDef.cell, cell.getContext()),
    [cell.column.columnDef.cell, cell.id, cell.row.original]
  );

  return (
    <MemoziedCellContent
      ref={setNodeRef}
      id={cell.column.id}
      content={content}
      isDragging={isDragging}
      transform={transform}
      transition={transition}
    />
  );
};

DraggableCell.propTypes = {
  cell: PropTypes.object.isRequired,
};

export default DraggableCell;
